module.exports = __webpack_public_path__ + "media/images/new_pin-73561b1d.jpg";